import { render, staticRenderFns } from "./AddToGlobe.vue?vue&type=template&id=83ae4448&scoped=true&"
import script from "./AddToGlobe.vue?vue&type=script&lang=js&"
export * from "./AddToGlobe.vue?vue&type=script&lang=js&"
import style0 from "./AddToGlobe.vue?vue&type=style&index=0&id=83ae4448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ae4448",
  null
  
)

export default component.exports